import { render, staticRenderFns } from "./CompanyIndexPage.vue?vue&type=template&id=54d7bf74&"
import script from "./CompanyIndexPage.vue?vue&type=script&lang=js&"
export * from "./CompanyIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports